// React imports.
import * as React from 'react';

interface ResetOverlayProps {
  onRestartExercise: () => void;
}

/**
 * Stateless functional components, renders an reset overlay component.
 *
 * @param props The properties this component receives
 * @returns {JSX.Element} The element that needs to be rendered.
 */
const ResetOverlay = (props: ResetOverlayProps): JSX.Element => (
  <div className="reset-overlay">
    <div>
      <p>Exercise paused</p>
      <button className="reset-overlay__button" onClick={props.onRestartExercise}>Continue</button>
    </div>
  </div>
);

export default ResetOverlay;



// WEBPACK FOOTER //
// ./src/components/ResetOverlay.tsx